import React from 'react'
import './labs.css'

const Labs = () => {
    return (
        <div>
            zenith is here with the labs
        </div>
    )
}

export default Labs